"use strict";

import * as modal from "./_modal";
import { gsap, Power3, Power0 } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
// import TweenMax from "gsap";
import Swiper, { Navigation, Pagination, Autoplay } from "swiper/swiper-bundle";

gsap.registerPlugin(EaselPlugin, ScrollTrigger);
Swiper.use([Navigation, Pagination, Autoplay]);
modal.init();
// - - - - - - - - - - - - - - - - - - - -
//
// rel swiper
//
// - - - - - - - - - - - - - - - - - - - -
window.addEventListener("load", () => {
  stepLetter();
  kvSlider();
  donutSlider();
  contentSwiper1();
  contentSwiper2();
  kvController();
  // bannerHidden();
});
function kvSlider() {}
const kvSwiper = new Swiper(".kv-carousel .swiper-container", {
  autoplay: {
    delay: 2700,
    loop: true,
  },
  speed: 1000,
  effect: "fade",
  allowTouchMove: false,
  fadeEffect: {
    crossFade: true,
  },
  on: {
    slideChange: () => {
      const figureBlock = document.querySelectorAll(".figure-block");
      // const activeIndex = kvSwiper.activeIndex;
      // console.log(activeIndex);
      // console.log(figureBlock);
      figureBlock.forEach((item, i) => {
        if (kvSwiper.activeIndex == 0) {
          // window.alert("1枚目のスライド");
          figureBlock[1].classList.remove("is-active");
          figureBlock[2].classList.remove("is-active");
          figureBlock[0].classList.add("is-active");
        }
        if (kvSwiper.activeIndex == 1) {
          // window.alert("２枚目のスライド");
          figureBlock[0].classList.remove("is-active");
          figureBlock[2].classList.remove("is-active");
          figureBlock[1].classList.add("is-active");
        }
        if (kvSwiper.activeIndex == 2) {
          // window.alert("３枚目のスライド");
          figureBlock[0].classList.remove("is-active");
          figureBlock[1].classList.remove("is-active");
          figureBlock[2].classList.add("is-active");
        }
      });
    },
  },
});

function donutSlider() {
  let swiperThumb = new Swiper(".slider-thumb", {
    clickable: true, //この行を追記する
    on: {
      click: function () {
        document
          .querySelector(".donut-countdownbar__line")
          .classList.add("exit");
        // console.log("click");
        gsap.fromTo(
          ".donut-countdownbar__line",
          0,
          {
            // ease: Power0.easeNone,
            strokeDashoffset: 0,
          },
          {
            strokeDashoffset: 0,
          }
        );
      },
    },
  });
  let donutSwiperOption = {
    loop: true,
    autoHeight: true,
    autoplay: {
      delay: 8000,
      // disableOnInteraction: false, // ユーザが操作しても自動再生を継続させる
    },
    // speed: 1000,
    effect: "fade",
    allowTouchMove: false,
    fadeEffect: {
      crossFade: true,
    },
    thumbs: {
      swiper: swiperThumb,
    },
    pagination: {
      el: ".donut-pagination",
      type: "fraction", // 枚数表示
      formatFractionCurrent: function (number) {
        // １０以下のスライドには0を頭につける
        if (number < 10) {
          return "0" + number;
        } else {
          return number;
        }
      },
      renderFraction: function (currentClass, totalClass) {
        return (
          '<span class="' +
          currentClass +
          '"></span>' +
          '<span class="' +
          "pagination-line" +
          '"></span>' +
          '<span class="' +
          totalClass +
          '"></span>'
        );
      },
    },
    on: {
      slideChangeTransitionStart: function () {
        const donutCounter = document.querySelector(
          ".donut-countdownbar__line"
        );
        gsap.fromTo(
          donutCounter,
          8.5,
          {
            // ease: Power0.easeNone,
            strokeDashoffset: 100,
          },
          {
            strokeDashoffset: 0,
          }
        );
      },
      slideChange: function () {
        const activeDonut = document.querySelectorAll(".donut-content");
        activeDonut.forEach((item, index) => {
          item.classList.remove("is-active");
          if (swiperThumb.activeIndex == index) {
            item.classList.add("is-active");
          }
        });
      },
      onClick: function () {
        document
          .querySelector(".donut-countdownbar__line")
          .classList.add("add");
        // console.log("click");
        gsap.fromTo(
          donutCounter,
          0,
          {
            // ease: Power0.easeNone,
            strokeDashoffset: 0,
          },
          {
            strokeDashoffset: 0,
          }
        );
      },
    },
  };
  let donutSwiper = new Swiper(".donut-slider", donutSwiperOption);
}
function contentSwiper1() {
  // let contentSwiper1Option = {
  //   // loop: true,
  //   autoHeight: true,
  //   allowTouchMove: true,
  //   autoplay: {
  //     delay: 5000,
  //     // disableOnInteraction: false, // ユーザが操作しても自動再生を継続させる
  //   },

  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  //   slidesPerView: 1.3,
  //   // spaceBetween: 1,

  //   centeredSlides: true,
  //   speed: 1000,
  //   // on: {
  //   //   slideChange: function () {
  //   //     // console.log("swiper slideChange");
  //   //     const slideIndex = this.realIndex + 1;
  //   //     const explanelTarget = document.querySelector(
  //   //       ".content-carousel2--explane0" + slideIndex
  //   //     );
  //   //     // explanelTarget.classList.add("is-active");
  //   //     // explanelTarget.classList.remove("is-active");
  //   //   },
  //   // },
  // };
  let contentSwiper1 = new Swiper(
    ".content-carousel-slider--01",
    contentSwiperOption
  );
}
let contentSwiperOption = {
  initialSlide: 0,
  // autoHeight: true,

  allowTouchMove: true,
  autoplay: {
    delay: 5000,
    // disableOnInteraction: false, // ユーザが操作しても自動再生を継続させる
  },
  // modules: [Navigation],
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  slidesPerView: 1.3,
  // spaceBetween: 1,

  centeredSlides: true,
  speed: 1000,
  // on: {
  //   slideChange: function () {
  //     // console.log("swiper slideChange");
  //     const slideIndex = this.realIndex + 1;
  //     const explanelTarget = document.querySelector(
  //       ".content-carousel2--explane0" + slideIndex
  //     );
  //     // explanelTarget.classList.add("is-active");
  //     // explanelTarget.classList.remove("is-active");
  //   },
  // },
};
function contentSwiper2() {
  let contentSwiper2 = new Swiper(
    ".content-carousel-slider--02",
    contentSwiperOption
  );
}
function stepLetter() {
  const kvLetter = document.querySelectorAll(".step-letter");
  gsap.to(kvLetter, {
    // delay: 0.2,
    duration: 1,
    x: 0,
    opacity: 1,
    ease: "power2.out",
    // 複数要素を扱うプロパティ
    stagger: {
      from: "start", //左側から
      amount: 1, // 0.8秒おきに
    },
  });
}
// スライダーの自動再生停止・開始ボタン
function kvController() {
  const startButton = document.querySelector(".controller-button-start");
  const stopButton = document.querySelector(".controller-button-stop");
  startButton.addEventListener("click", () => {
    startButton.classList.add("active");
    stopButton.classList.remove("active");
    kvSwiper.autoplay.start();
  });
  stopButton.addEventListener("click", () => {
    stopButton.classList.add("active");
    startButton.classList.remove("active");
    kvSwiper.autoplay.stop();
  });
}

// - - - - - - - - - - - - - - - - - - - -
//
// index modal
//
// - - - - - - - - - - - - - - - - - - - -
// const modalClose = document.querySelector(".index-cover__button");
// modalClose.addEventListener("click", () => {
//   document.querySelector(".index-cover").classList.add("is-remove");
// });

// - - - - - - - - - - - - - - - - - - - -
//
// rel container
//
// - - - - - - - - - - - - - - - - - - - -
const marinDayBanner = document.querySelector(".figure-banner");
ScrollTrigger.create({
  trigger: "#section3",
  start: "top 50%",
  endTrigger: ".footer",
  end: "top center",
  // scroller: ".container__main",

  toggleClass: {
    targets: marinDayBanner,
    className: "is-view",
  },
});
const carouselController = document.querySelector(".carousel-controller");
ScrollTrigger.create({
  trigger: "#section3",
  start: "top 50%",
  endTrigger: ".footer",
  end: "top center",
  // scroller: ".container__main",

  toggleClass: {
    targets: carouselController,
    className: "is-hidden",
  },
});

// - - - - - - - - - - - - - - - - - - - - - - - - - -
// banner Click
// - - - - - - - - - - - - - - - - - - - - - - - - - -
function bannerHidden() {
  const banner = document.querySelector(".stickey-footer-banner");
  const bannerButton = document.querySelector(".stickey-footer-banner__close");
  bannerButton.addEventListener("click", () => {
    banner.classList.add("is-hidden");
  });
}
// - - - - - - - - - - - - - - - - - - - - - - - - - -
// image horizone scroll
// - - - - - - - - - - - - - - - - - - - - - - - - - -
const scrollArea = document.querySelectorAll(".js-scroll-alert");
// 検知
function createEventScrollX(ele) {
  this._past_scroll_left = 0;
  this.ev_scroll_x = new CustomEvent("scroll-x", {
    bubbles: true,
    cancelable: true,
  });
  this.dispatch_callback = function (ev) {
    var cuT = ev.currentTarget;
    var now_l = cuT.scrollLeft;
    if (now_l !== this.past_scroll_left) {
      ele.dispatchEvent(this.ev_scroll_x);
      this.past_scroll_left = now_l;
    }
  };

  var events = ["scroll", "touchmove"];
  events.forEach(
    function (ev, idx, arr) {
      ele.addEventListener(ev, this.dispatch_callback.bind(this), {
        capture: true,
        passive: true,
      });
    }.bind(this)
  );
}

for (let i = 0; i < scrollArea.length; i++) {
  var evX = new createEventScrollX(scrollArea[i]);
  scrollArea[i].addEventListener(
    "scroll-x",
    function (ev) {
      let target =
        ev.currentTarget.getElementsByClassName("js-touch-scroll")[0];
      target.classList.add("is-hidden");
    },
    { capture: true, passive: true }
  );
}
